import { Button, Container, SvgIcon, Tooltip } from "@mui/material";
import { useAppDispatch, useAppSelector } from "app/hooks"
import Header from "components/header/Header";
import SearchBar from "components/inputs/HolzfinderSearchBar";
import HolzfinderList from "components/list/HolzfinderList";
import { resetNewSeller } from "features/seller/newSellerSlice";
import { getSellersList, selectSellersList, selectSellersListTotal } from "features/sellersList/sellersListSlice"
import { selectPageSeller, selectRowsPerPageSeller, setPageSellerList, setRowsPerPageSellerList } from "features/table/tableSlice";
import { selectUserRole } from "features/user/userSlice";
import { Add } from "icons";
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";


interface rowInterface {
  id: string;
  company: string;
  street: string;
  street_number: string;
  zip_code: string;
  city: string;
  eldat_reference_id: number;
  county_eldat_reference_id?: number
}
const tableHeaderListAdmin: string[] = ["Kreisnr.", "Betriebsnr.", "Betriebsname", "Straße", "Hausnummer", "Postleitzahl", "Stadt", "Bearbeiten"]
const tableHeaderListAgent: string[] = ["Betriebsnr.", "Betriebsname", "Straße", "Hausnummer", "Postleitzahl", "Stadt", "Bearbeiten"]

export default function SellersList() {
  const [rowData, setRowData] = useState<rowInterface[]>([]);
  const [searchQuery, setSearchQuery] = React.useState("");
  const sellersList = useAppSelector(selectSellersList);
  const sellersListTotal = useAppSelector(selectSellersListTotal);
  const page = useAppSelector(selectPageSeller)
  const rowsPerPage = useAppSelector(selectRowsPerPageSeller)
  const dispatch = useAppDispatch();
  const userRole = useAppSelector(selectUserRole)
// Removed unused state variables `pageCache` and `rowsPerPageCache`.
  const navigate = useNavigate();
  const receiveSellersList = useCallback((resetSearch: boolean) => {
    if (resetSearch) setSearchQuery("")
    dispatch(
      getSellersList({
        items_per_page: rowsPerPage,
        page: page + 1,
        search: resetSearch ? undefined : searchQuery,
      })
    );
  }, [dispatch, rowsPerPage, page, searchQuery]);

  useEffect(() => {
    receiveSellersList(false)
  }, [page, rowsPerPage, searchQuery, receiveSellersList]);
  useEffect(() => {
    if (searchQuery) {
      dispatch(setPageSellerList(0));
    }
  }, [searchQuery, dispatch]);

  useEffect(() => {
    if (userRole === "admin") {
      const mappedData = sellersList.map(
        (seller) => ({
          id: seller.id,
          county_eldat_reference_id: seller.county?.eldat_reference_id,
          eldat_reference_id: seller.eldat_reference_id,
          company: seller.company ? seller.company : `${seller.first_name ?? ""} ${seller.last_name ?? ""}`,
          street: seller.street,
          street_number: seller.street_number,
          zip_code: seller.zip_code,
          city: seller.city,
        })
      );
      setRowData(mappedData);
    } else {
      const mappedData = sellersList.map(
        (seller) => ({
          id: seller.id,
          eldat_reference_id: seller.eldat_reference_id,
          company: seller.company ? seller.company : `${seller.first_name ?? ""} ${seller.last_name ?? ""}`,
          street: seller.street,
          street_number: seller.street_number,
          zip_code: seller.zip_code,
          city: seller.city,
        })
      );
      setRowData(mappedData);
    }
  }, [sellersList, userRole])
  useEffect(() => {
    dispatch(setPageSellerList(0));
  }, [searchQuery, dispatch]);

  const handleNewSellerClick = () => {
    dispatch(resetNewSeller());
    navigate('verkaeufer_hinzufuegen');
  }

  return (
    <Container sx={{ pl: { lg: 12, md: 12, xs: 12 }, pt: 5 }} maxWidth="xl">
      <Header header="Verkäuferliste" />

      <SearchBar page={page} rowsPerPage={rowsPerPage} getListType={getSellersList} setSearchQuery={setSearchQuery} />
      <Tooltip title="Neuanlage Verkäufer" placement="bottom">
        <Button sx={{ backgroundColor: "#c0d904", color: "rgba(0,0,0,0.5)", minWidth: 48, height: 48, borderRadius: "100%", mt: 2, mb: 2, float: "right" }} onClick={handleNewSellerClick} >
          <SvgIcon>
            <Add />
          </SvgIcon>
        </Button>
      </Tooltip>

      <HolzfinderList
        listLengthTotal={sellersListTotal}
        rowData={rowData}
        switchActive={false}
        link={`/${userRole}/verkaeuferliste/`}
        tableHeaderList={userRole === "admin" ? tableHeaderListAdmin : tableHeaderListAgent}
        setPage={setPageSellerList}
        setRowsPerPage={setRowsPerPageSellerList}
        page={page}
        rowsPerPage={rowsPerPage === undefined ? 10 : rowsPerPage}
        isLotList={false}
      />
    </Container>
  )
}